import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';

@Injectable({
  providedIn: 'root'
})
export class SummaryApi extends ApiCommon {

  getSummaryByDealer(params: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.params = params;
    return this.apiServer.summary.getSummaryByDealer(builder.build());
  }

  getSummaryByAgent(params: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.params = params;
    return this.apiServer.summary.getSummaryByAgent(builder.build());
  }

}
